export default defineNuxtRouteMiddleware((to, from) => {

    const error = useError();

    if (error.value) {
      return navigateTo('/wrong', { redirectCode: 404 });
    }

    if (!to.matched.length) {
      return navigateTo('/wrong', { redirectCode: 404 });
    }
  });
  